import {gql} from '@apollo/client';
import {DeliveryTaskOrderType, DSP_ORDER_FIELDS} from '../../../delivery/graphql/types/DeliveryTaskOrderType';

export const GET_DSP_DELIVERY_TASK_ORDER_LIST = gql`
  query DeliveryQuery($warehouseId: Long) {
    getDeliveryTaskOrderListByDspId(warehouseId: $warehouseId){
      ...DeliveryTaskOrderFields
    }
  }
  ${DSP_ORDER_FIELDS}
`;

export interface DspDeliveryTaskOrderListResponse {
    getDeliveryTaskOrderListByDspId: DeliveryTaskOrderType[];
} 